import {Select, Text} from '../1elements'
import FormHelperText from '@mui/material/FormHelperText'

const CountrySelect = ({disabled, onChange, value, validation}) => {
    const options = ['Canada']

    const setValue = (value) => {
        onChange(value)
    }

    return(
        <div>
            <Text type={'fieldLabel'}>Country<span className={'requiredAsterisk'}>*</span></Text>
            <Select disabled={disabled} onChange={setValue} options={options} value={value} />
            <FormHelperText error={Boolean(validation)}>{validation}</FormHelperText>
        </div>
    )
}

export default CountrySelect
